import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
export const IconMoon = ({ ...props }) => {
    const id = useId();
    return (<IconWithGradient id={id} {...props} defaultGradientKey="skyBlue">
      <Path d="M12.184 4.834A.488.488 0 0 0 11.813 4c-1.981.104-3.846.938-5.387 2.377l-.012.012c-3.219 3.218-3.219 8.509 0 11.727 3.219 3.22 8.51 3.22 11.728 0 1.456-1.456 2.285-3.427 2.389-5.398a.489.489 0 0 0-.833-.371c-2.088 2.087-5.684 2.318-7.71.293-2.055-2.056-2.056-5.556 0-7.612l.19-.19h.001l.001-.002.004-.003Z" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
